import React from "react";
import { useField } from "formik";
import ExpandableTextarea from "./ExpandableTextarea";

export default function FormikTextarea({ className, ...props }) {
    const [field, meta] = useField(props);
    return (
        <ExpandableTextarea
            {...field}
            {...props}
            className={className}
            error={meta.touched && meta.error ? meta.error : undefined}
            touched={meta.touched}
        />
    );
}
